import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import Delete from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TableRow from '@mui/material/TableRow';
import SortableTableLabel from '../../components/Table/SortableTableLabel';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import jwtDecode from 'jwt-decode'; // ✅ 1. เพิ่ม import jwtDecode
import { addCommas } from '../../utils/functions/commas';
import DrawerTxnDetail from '../../components/Modal/DrawerTxnDetail';
import Loading from '../../components/Loading';
import {
  useWaitingForPaymentQuery,
  useDeleteWaitingMutation,
} from '../../services/paymentTransaction';
import WaitingUploadPayment from './WaitingUploadPayment';
import NotiAlertComfirmDel from '../../components/NotiAlert/NotiAlertComfirmDel';
import NotiAlert from '../../components/NotiAlert/NotiAlert';
import CircularProgress from '@mui/material/CircularProgress';

import { useTranslation } from 'react-i18next';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#fff',
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
  '&:hover': {
    boxShadow: '0 6px 16px rgba(0,0,0,0.12)',
    position: 'relative',
    zIndex: 10,
    cursor: 'pointer',
  },
  transition: 'transform 0.15s ',
}));

function WaitingForPayment() {
  const { t } = useTranslation();
  const columns = [
    { id: 'order_id_ref', label: t('app.transactionRefNo'), minWidth: 100 },
    {
      id: 'total_amount',
      label: t('app.totalAmountThb'),
      minWidth: 100,
      align: 'center',
    },
    {
      id: 'total_fines',
      label: t('app.lateFeeThb'),
      minWidth: 100,
      align: 'center',
    },
    {
      id: 'total_discount',
      label: t('app.discount'),
      minWidth: 100,
      align: 'center',
    },
    { id: 'total_vat', label: t('app.vat'), minWidth: 100, align: 'center' },
    { id: 'total_wht', label: t('app.wht'), minWidth: 100, align: 'center' },
    {
      id: 'total_pay_amount',
      label: t('app.grandTotal'),
      minWidth: 120,
      align: 'center',
    },
    {
      id: 'description',
      label: t('app.detail'),
      minWidth: 100,
      align: 'center',
    },
    {
      id: 'payment',
      label: t('app.payment'),
      minWidth: 100,
      align: 'center',
      sortable: false,
    },
    { id: 'action', label: t('app.cancel'), minWidth: 100, sortable: false },
  ];

  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [sortBy, setSortBy] = useState('createdAt');
  const [sortOrder, setSortOrder] = useState('desc');
  const [total, setTotal] = useState(0);
  const [waitingForPaymentUser, setwaitingForPaymentUser] = useState([]);
  const [waitingForApply, setWaitingForApply] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [dataRowDetail, setDataRowDetail] = useState([]);

  const [search, setSearch] = useState('');
  const [openDel, setOpenDel] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [openAlertErr, setOpenAlertErr] = useState(false);
  const {
    value: custNO,
    federal_hash_tax_id,
    federalTaxId,
  } = useSelector((state) => state.custNO);
  const merchant = useSelector((state) => state.merchant.value);
  const [deleteWaiting, responseDeleteWaiting] = useDeleteWaitingMutation();
  const [openDialogPaymentWaiting, setOpenDialogPaymentWaiting] =
    useState(false);
  const location = useLocation();
  const { OrderValue } = location.state || {};
  const [data, setData] = useState(OrderValue);

  // ✅ 2. ดึง Role จาก Token เพื่อใช้เช็คสิทธิ์
  const token = localStorage.getItem('token');
  const decodedToken = token ? jwtDecode(token) : null;
  const userRole = decodedToken?.ROLE || '';

  const {
    data: paymentTransaction,
    isLoading,
    refetch,
    isFetching,
  } = useWaitingForPaymentQuery(
    {
      customerCode: merchant ? custNO : '',
      sorgcode: merchant || '',
      size: rowsPerPage,
      page: page + 1,
      status: '',
      hashTaxId: federal_hash_tax_id || '',
      federalTaxId: federalTaxId || '',
      search,
      sortBy,
      sortOrder,
    },
    {
      refetchOnMountOrArgChange: true,
      skip: !custNO && (userRole === 'SUPER ADMIN' || userRole === 'SALE'),
    },
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleOpenDialogPayment = (item) => {
    setOpenDialogPaymentWaiting(true);
    setDataRowDetail(item);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleRequestSort = (property) => {
    setSortOrder(
      sortBy === property && sortOrder === 'asc' ? 'desc' : 'asc',
    );
    setSortBy(property);
    setPage(0);
  };
  const handleOnClose = () => {
    setOpenAlert(false);
  };
  const handleOnCloseErr = () => {
    setOpenAlertErr(false);
  };

  useEffect(() => {
    if (paymentTransaction) {
      const { pagination, data: rows } = paymentTransaction;
      setTotal(pagination.total);
      setwaitingForPaymentUser(rows);
      setWaitingForApply(rows);
    }
    return () => {};
  }, [paymentTransaction]);

  useEffect(() => {
    if (data) {
      const findMatchingObject = (arr, obj) =>
        arr.find((item) => item.order_id_ref === obj.order_id_ref);
      const matchingObject = findMatchingObject(waitingForApply, data);

      if (matchingObject) {
        setOpenDrawer(true);
        setDataRowDetail(matchingObject);
      }
    }
  }, [waitingForApply, data]);

  const handleDeleteWaiting = async (id) => {
    try {
      const payload = {
        params: {
          id,
        },
        body: {
          customerCode: custNO,
          sorgcode: merchant,
          federalTaxId: federalTaxId || '',
        },
      };
      const res = await deleteWaiting(payload);
      if (res.data.statusCode === 200) {
        setOpenDel(false);
        setOpenAlert(true);
        refetch();
      } else {
        setOpenAlertErr(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="flex flex-col">
      <div className="font-bold">{t('app.pendingPayments')}</div>
      <div className="w-full lg:w-[20%]">
        <Paper
          component="form"
          sx={{
            p: '2px 4px',
            display: 'flex',
            alignItems: 'center',
            marginTop: 2,
          }}
        >
          <InputBase
            className='"app-search-input'
            type="text"
            sx={{ ml: 1, flex: 1, width: 300 }}
            onChange={(e) => {
              setSearch(e.target.value);
              refetch();
            }}
            placeholder={t('app.search')}
          />

          <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
          <div className="p-2">
            <SearchIcon sx={{ fontSize: '24px' }} color="primary" />
          </div>
        </Paper>
      </div>

      <div className="flex flex-col mt-5">
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
     <TableContainer sx={{ overflowX: 'auto', overflowY: 'visible' }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <StyledTableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      <div style={{ whiteSpace: 'nowrap', padding: 5 }}>
                      <SortableTableLabel
                        column={column}
                        sortBy={sortBy}
                        sortOrder={sortOrder}
                        onSort={handleRequestSort}
                        color="white"
                      />
                      </div>
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {isFetching ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <div className="flex justify-center items-center py-8">
                        <CircularProgress />
                      </div>
                    </TableCell>
                  </TableRow>
                ) : _.size(waitingForPaymentUser) > 0 ? (
                  _.map(waitingForPaymentUser, (item, index) => (
                    <StyledTableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={index}
                    >
                      {columns.map((column) => {
                        const value = item[column.id];

                        if (column.id === 'description') {
                          return (
                            <TableCell key={column.id} align={column.align}>
                              <IconButton
                                color="success"
                                onClick={() => {
                                  setOpenDrawer(true);
                                  setDataRowDetail(item);
                                }}
                              >
                                <VisibilityIcon />
                              </IconButton>
                            </TableCell>
                          );
                        }
                        if (column.id === 'payment') {
                          return (
                            <TableCell key={column.id} align={column.align}>
                              <IconButton
                                color="success"
                                onClick={() => handleOpenDialogPayment(item)}
                              >
                                <UploadFileIcon />
                              </IconButton>
                            </TableCell>
                          );
                        }
                        if (column.id === 'action') {
                          return (
                            <TableCell key={column.id} align={column.align}>
                              <IconButton
                                color="error"
                                onClick={() => {
                                  setOpenDel(true);
                                  setDataRowDetail(item);
                                }}
                              >
                                <Delete />
                              </IconButton>
                            </TableCell>
                          );
                        }

                        if (
                          [
                            'total_pay_amount',
                            'total_vat',
                            'total_amount',
                            'total_wht',
                            'total_discount',
                            'total_fines',
                          ].includes(column.id)
                        ) {
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {addCommas(value)}
                            </TableCell>
                          );
                        }

                        if (column.id === 'order_id_ref') {
                          return (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              sx={{
                                color: 'primary.main',
                                fontWeight: 'bold',
                                fontFamily: 'Monospace',
                              }}
                            >
                              {value}
                            </TableCell>
                          );
                        }

                        return (
                          <TableCell key={column.id} align={column.align}>
                            {value}
                          </TableCell>
                        );
                      })}
                    </StyledTableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <div>{t('app.noDataAvailable')}</div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[5, 25, 100]}
            component="div"
            count={total}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelDisplayedRows={({ from, to, count }) =>
              `${from}–${to} of ${addCommas(count, 0)}`
            }
          />
        </Paper>
      </div>

      <DrawerTxnDetail
        openDrawer={openDrawer}
        setOpenDrawer={setOpenDrawer}
        dataRowDetail={dataRowDetail}
        setData={setData}
      />
      <NotiAlertComfirmDel
        open={openDel}
        setOpen={setOpenDel}
        dataRowDetail={dataRowDetail}
        handleDeleteWaiting={handleDeleteWaiting}
      />

      <NotiAlert
        open={openAlert}
        setOpen={setOpenAlert}
        title="ลบรายการสำเร็จ"
        value="success"
        onButtonClick={handleOnClose}
      />

      <NotiAlert
        open={openAlertErr}
        setOpen={setOpenAlertErr}
        title="ลบรายการไม่สำเร็จ"
        value="cancle"
        onButtonClick={handleOnCloseErr}
      />
      <WaitingUploadPayment
        refetchMain={refetch}
        setOpenDialogPaymentWaiting={setOpenDialogPaymentWaiting}
        openDialogPaymentWaiting={openDialogPaymentWaiting}
        setDataRowDetail={setDataRowDetail}
        dataRowDetail={dataRowDetail}
      />
    </div>
  );
}
export default WaitingForPayment;
